import { CheckoutSession, getCheckoutSessionById, patchSetCart } from '@nemuru-eng/js-api-client';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { BillingAndShippingMap } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/maps/billingAndShipping.map';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const useEditCart = (checkoutSession: CheckoutSession) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getCheckoutSessionById, { checkoutSessionId: checkoutSession.id });
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  // Uses data in application context to create DTO
  const {
    state: { cart, paymentMethodEntities, checkoutSessionId, orderReference1, orderReference2 },
  } = useApplicationContext();

  const editCart = async () => {
    if (!checkoutSession || !cart || !paymentMethodEntities || !checkoutSessionId) {
      return;
    }

    const clientSecret = await checkoutSessionEntity?.getClientSecret();
    if (!clientSecret) {
      return;
    }

    await request(patchSetCart, {
      id: checkoutSession.id,
      merchant: {
        orderReference1: orderReference1 as string,
        ...(orderReference2 && { orderReference2 }),
      },
      cart: cart.toDto(),
      billing: BillingAndShippingMap.billingToRequestDto(checkoutSession.billing),
      shipping: BillingAndShippingMap.shippingToRequestDto(checkoutSession.shipping),
      clientSecret,
    });

    revalidate();
  };

  return {
    cart,
    editCart,
    loading,
  };
};
